import Point = createjs.Point;

export class LayerInfo {
    private _position: Point;
    private _scale: number;
    private _index: number;
    private _layerName: string;
    private _rotation: number;

    constructor(posX: number, posY: number, scale: number, index: number, layerName: string, rotation: number = 0) {
        this._position = new Point(posX, posY);
        this._scale = scale;
        this._index = index;
        this._layerName = layerName;
        this._rotation = rotation;
    }

    public get layerName(): string {
        return this._layerName;
    }

    public get index(): number {
        return this._index;
    }

    public get position(): Point {
        return this._position;
    }

    public get scale(): number {
        return this._scale;
    }

    public get rotation(): number {
        return this._rotation;
    }
}
